import { useQuery } from '@tanstack/react-query';

import { parseMetadata } from 'helpers/metadataParser';

import { businessPlanQueryKeys } from '../businessPlan-qk';
import { BusinessPlanApi } from '../businessPlan.api';

export const useGetBusinessPlan = ({ id, enabled }: { id: string; enabled: boolean }) => {
  return useQuery({
    queryKey: businessPlanQueryKeys.businessPlan(id),
    queryFn: () => BusinessPlanApi.getBusinessPlan(id),
    select: (businessPlan) => ({ ...businessPlan, metadata: parseMetadata(businessPlan.metadata) }),
    enabled,
  });
};
